import {
  IonHeader,
  IonTitle,
  IonToolbar,
  IonContent,
  IonPage,
  IonButtons,
  isPlatform,
  IonListHeader,
  IonLabel,
  IonMenuButton,
} from "@ionic/react";

// Components
import { AccountSlides } from "./components/AccountSlides";
import { PaymentNoticeCreateButton } from "./components/PaymentNoticeCreateButton";
import { PaymentNoticeListByDate } from "./components/PaymentNoticeListByDate";

export const PaymentNoticesList: React.FC = () => {
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light"></IonMenuButton>
          </IonButtons>
          <IonTitle>Contabilidad</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Contabilidad</IonTitle>
          </IonToolbar>
        </IonHeader>

        <section
          style={{
            maxWidth: "800px",
          }}
          className={isPlatform("desktop") ? "ion-padding" : ""}
        >
          <AccountSlides />
          <br />
          <IonListHeader>
            <IonLabel>
              <h2>
                <strong>Abonos</strong>
              </h2>
            </IonLabel>
            <PaymentNoticeCreateButton />
          </IonListHeader>
          <PaymentNoticeListByDate />
        </section>
      </IonContent>
    </IonPage>
  );
};
